import { notification } from "antd";
import { useCallback } from "react";
import { NavigateFunction } from "react-router-dom";
import {
  useCreateEventCommentMutation,
  useFetchProjectCommentsQuery,
  useProjectArchiveMutation,
  useProjectCloseMutation,
} from "../../apiSlice";
import { CommentPostValues } from "../../../../types/comments";
import { getErrorMessage } from "../../../../utils/errors/errors";

type Options = {
  fetchProjects?: () => void;
  fetchProject?: () => void;
  navigate?: NavigateFunction;
  projectId?: number;
};

export const useCrudProject = ({
  fetchProjects,
  fetchProject,
  navigate,
  projectId,
}: Options = {}) => {
  /**
   * Close
   */
  const [closeProject, { isLoading: isClosing }] = useProjectCloseMutation();
  const onClose = useCallback(
    async (id: number) => {
      try {
        await closeProject(id).unwrap();
        notification.success({ message: "Le projet a Ã©tÃ© clÃ´turÃ© avec succÃ¨s." });
        if (fetchProject) {
          fetchProject();
        }
      } catch (error) {
        notification.error({
          message: "Erreur",
          description: getErrorMessage(error),
        });
      }
    },
    [closeProject, fetchProject],
  );

  /**
   * Archive
   */
  const [archiveProjectRequest, { isLoading: isArchiving }] =
    useProjectArchiveMutation();
  const archiveProject = useCallback(
    async (id: number) => {
      try {
        await archiveProjectRequest(id).unwrap();
        notification.success({
          message: "Le projet a Ã©tÃ© archivÃ© avec succÃ¨s.",
        });
        if (navigate) {
          navigate("/pdca/projets");
        } else if (fetchProjects) {
          fetchProjects();
        } else if (fetchProject) {
          fetchProject();
        }
      } catch (error) {
        notification.error({
          message: "Erreur",
          description: getErrorMessage(error),
        });
      }
    },
    [archiveProjectRequest, navigate, fetchProjects, fetchProject],
  );

  /**
   * Comments
   */
  const { data: comments, refetch: refetchComments } =
    useFetchProjectCommentsQuery(projectId as number, { skip: !projectId });
  const [createCommentRequest, { isLoading: isCreatingComment }] =
    useCreateEventCommentMutation();
  const createComment = useCallback(
    async (values: Pick<CommentPostValues, "description">) => {
      if (!projectId) return;
      try {
        await createCommentRequest({
          description: values.description,
          commentType: "PROJECT",
          project: projectId,
        }).unwrap();
        notification.success({ message: "Commentaire ajoutÃ©." });
        refetchComments();
      } catch (error) {
        notification.error({
          message: "Erreur",
          description: getErrorMessage(error),
        });
      }
    },
    [createCommentRequest, projectId, refetchComments],
  );

  return {
    onClose,
    isClosing,
    archiveProject,
    isArchiving,
    comments,
    createComment,
    isCreatingComment,
  };
};
